// Pure data — RSC-safe. How a Blood Vision test is booked per region: 'web'
// goes to /blood-vision/buy, 'app' hands off to the Ultrahuman app, null means
// not offered. Read by the /blood-vision/buy edge redirect, the buy page's
// in-render fallback, and the /blood-vision header and landing-page CTAs.
const WEB_BOOKING_REGIONS = new Set(['US', 'IN']);
const APP_BOOKING_REGIONS = new Set(['AE']);

export type BloodVisionBooking = 'web' | 'app' | null;

export const getBloodVisionBooking = (region: string): BloodVisionBooking => {
  if (WEB_BOOKING_REGIONS.has(region)) return 'web';
  if (APP_BOOKING_REGIONS.has(region)) return 'app';
  return null;
};
